module.exports = __webpack_public_path__ + "1af6ccb2.svg";